import groupBy from 'lodash/groupBy'

import Notification from '../../Notification/Notification'
import { suggestForAssets } from './assets'
import {
  allOperators,
  basicOperators,
  comparisonOperator,
  modules,
  stringOperators,
  taxonomyTermOperators
} from './constant'
import { suggestForEntries } from './entries'

const cbNameByQueryType = {
  contentTypeLabel: 'fetchContentTypes',
  languageLabel: 'fetchLanguages',
  userLabel: 'fetchUsers',
  environmentLabel: 'fetchEnvironments',
  entriesTagLabel: 'fetchEntriesTags',
  referenceLabel: 'fetchEntries',
  fileLabel: 'fetchAssets',
  assetTagLabel: 'fetchAssetTags',
  typeLabel: 'fetchAssetTypes',
  taxonomyTermLabel: 'fetchTaxonomies'
  // customFieldReferenceLabel: 'fetchEntries',
  // customFieldFileLabel: 'fetchAssets'
  //   inWorkflowStage: 'fetchWorkflowStage'
}

//fetch data generic method
export const handleDataFetch = async (data) => {
  const { skip, limit, inputValue, queryType, fetchData, suggestionsLength, query } = data
  try {
    const cbName = cbNameByQueryType[queryType]
    const dataFetchHandler = fetchData[cbName]
    console.log(' handleDataFetch ~ data:', data, cbName)
    if (dataFetchHandler) {
      let payload: any = {
        skip,
        limit,
        inputValue,
        suggestionsLength
      }

      if (query) {
        payload.query = query
      }

      const response: any = await dataFetchHandler(payload)
      // console.log(' handleDataFetch :', response)
      return response
    }
    return { data: [], count: 0 }
  } catch (error) {
    console.log('handleDataFetch -> error', error)
  }
}

export const getSuggestionsLength = (suggestions) => {
  let length = 0
  suggestions.forEach((query) => {
    length = length + query.options.length
  })
  return length
}

export const setCounterForAdvanceQuery = (queryArray, counter) => {
  queryArray.map((obj) => {
    counter = counter + 1
    obj.cursorY = counter
    if (obj.queryArray.length) {
      obj.queryArray.map((eachObjQuery) => {
        counter = counter + 1
        eachObjQuery.queryCursorY = counter
      })

      // obj.queryCursorY = counter + 1
      // counter = counter + 1
    }
    if (obj.children.length) {
      let updatedCounter = setCounterForAdvanceQuery(obj.children, counter)
      counter = updatedCounter
    }
  })
  return counter
}

export const autoSuggest = async (data) => {
  //if selectedDrop value is ENtries then handle suggest
  if (data.selectedModule === modules[0].value) {
    const object: any = await suggestForEntries(data)
    return object
  }

  // if selected value is Assets
  if (data.selectedModule === modules[1].value) {
    const object: any = await suggestForAssets(data)
    return object
  }

  return {
    withOperator: false,
    queryData: [],
    // isQueryCompleted: false,
    count: 0
  }
}

export const updateCurrentQuery = (data) => {
  let { queryType, selectedOpt, type, operators, currentQuery } = data

  if (type === 'key') {
    currentQuery.key = [selectedOpt]
    currentQuery.operator = [operators[0]]
    currentQuery.value = []
    currentQuery.queryType = queryType
    currentQuery.keyError = false
    return currentQuery
  }

  if (type === 'operator') {
    currentQuery.operator = [selectedOpt]
    currentQuery.operatorError = false
    return currentQuery
  }

  if (type === 'value') {
    currentQuery.value = [selectedOpt]
    currentQuery.valueError = false
    return currentQuery
  }
}

export const getOperatorsByQueryType = (queryType, key) => {
  // DONT REMOVE THIS, this is commented for SEPT 11 release
  // null not null check
  let operandKey = key[0]?.value || undefined
  let NullAndNotNullOperands = [
    'systemDefTitleLabel',
    'systemDefUrlLabel',
    'entriesTagLabel',
    'taxonomyTermLabel',
    'textInputLabel',
    'advTextInputLabel',
    'jsonRteTextLabel',
    'fileLabel',
    'numberLabel',
    'referenceLabel',
    'linkLabel',
    'fileNameLabel',
    'titleLabel',
    'urlLabel',
    'assetTagLabel'
    // 'customFieldJsonLabel'
  ]
  if (operandKey && !['_published_at', 'updated_at', 'created_at'].includes(operandKey)) {
    NullAndNotNullOperands.push('dateLabel')
  }

  const operatorsByQueryType = {
    dateLabel: allOperators.filter((op) => op.value != '$ne'),
    contentTypeLabel: stringOperators,
    advTextInputLabel: [stringOperators[1], stringOperators[3]],

    customFieldJsonLabel: [stringOperators[1], stringOperators[3]],
    jsonRteTextLabel: [stringOperators[1], stringOperators[3]],
    numberLabel: [...comparisonOperator, basicOperators[1]],
    linkLabel: stringOperators,
    textInputLabel: stringOperators,

    advSearchTextLabel: [stringOperators[1], stringOperators[3]],
    systemDefTitleLabel: stringOperators,
    systemDefUrlLabel: stringOperators,

    //assets
    fileSizeLabel: allOperators,
    fileNameLabel: stringOperators,
    titleLabel: stringOperators,
    urlLabel: stringOperators,
    taxonomyTermLabel: taxonomyTermOperators
  }
  // DONT REMOVE THIS, this is commented for SEPT 11 release
  // null not null check
  let finalOperator = JSON.parse(JSON.stringify(operatorsByQueryType[queryType] || basicOperators)) //operatorsByQueryType[queryType] || basicOperators
  if (NullAndNotNullOperands.includes(queryType) && finalOperator.filter((fi) => fi.value === '$exists').length === 0) {
    finalOperator.push(
      ...[
        {
          label: 'Is empty',
          value: '$exists'
        },
        {
          label: 'Is not empty',
          value: '$exists'
        }
      ]
    )
  }
  return finalOperator

  return operatorsByQueryType[queryType] || basicOperators
}

export const getTypeOfValueByQueryType = (queryType) => {
  const typeOfValueByQueryType = {
    uidLabel: 'text',
    textInputLabel: 'text',
    advTextInputLabel: 'text',
    numberLabel: 'number',
    dateLabel: 'date',
    linkLabel: 'text',
    jsonRteTextLabel: 'text',
    customFieldJsonLabel: 'text',

    advSearchTextLabel: 'text',
    systemDefTitleLabel: 'text',
    systemDefUrlLabel: 'text',

    // fileSizeLabel: 'number',
    fileNameLabel: 'text',
    urlLabel: 'text',
    titleLabel: 'text'
  }

  return typeOfValueByQueryType[queryType] || 'dropdown'
}

export const canFieldHaveSearch = (type, queryType, currentQuery) => {
  // debugger
  const { key = [], value } = currentQuery

  const allQueryTypeWithSearch = {
    contentTypeLabel: `Search content type`,
    languageLabel: `Search language`,
    userLabel: `Search user`,
    environmentLabel: `Search environment`,
    typeLabel: `Search ${key[0]?.label}`,
    referenceLabel: `Search ${key[0]?.label}`,
    fileLabel: `Search ${key[0]?.label}`,
    taxonomyTermLabel: 'Search  taxonomy & term',
    entriesTagLabel: 'Search tags',
    assetTagLabel: 'Search tags',
    workflowLabel: 'Search workflow stages'
  }

  const canSearch = type === 'key' || (type === 'value' && Object.keys(allQueryTypeWithSearch).includes(queryType))

  const searchPlaceholder =
    canSearch && (type === 'key' ? 'Search' : key[0]?.label ? allQueryTypeWithSearch[queryType] : '')

  return { canSearch, searchPlaceholder }
}

export const searchInStaticData = (allQueryData, inputValue) => {
  const searchedData = allQueryData.map((data) => {
    const options = data.options.filter((opt) => opt.label.toLowerCase().includes(inputValue.toLowerCase()))
    return { ...data, options }
  })

  const count = searchedData.reduce((sum, data) => sum + data.options.length, 0)
  return { data: searchedData, count }
}

export const notify = (message, type: 'warning' | 'error' | 'success' = 'warning') => {
  Notification({
    displayContent: { text: message },
    notifyProps: { hideProgressBar: true, position: 'bottom-center' },
    type
  })
}

export const groupEntriesByCt = (response) => {
  const inReference = {
    group: '',
    queryType: 'referenceLabel',
    type: 'value',
    options: []
  }

  let data = []
  if (response.count) {
    let groupedObj = groupBy(response.data, (data) => {
      return [data.ctUid]
    })

    Object.keys(groupedObj).forEach((k) => {
      const valueArray = groupedObj[k]
      data.push({ ...inReference, group: valueArray[0].ctTitle, options: valueArray })
    })
    return data
  }
  return data
}

export const getFileSizes = ({ inputValue }) => {
  if (inputValue) {
    const num = +inputValue
    const options = [
      { label: `${num} KB`, value: num * 1024, enteredValue: inputValue },
      { label: `${num} MB`, value: num * Math.pow(1024, 2), enteredValue: inputValue }
    ]

    return options
  }
  // const regexNum = /^\d+$/
  // if (regexNum.test(inputValue)) {
  //   const num = parseInt(inputValue)
  // }

  return []
}

export const getFileSizeLabel = (value) => {
  const kbValue = value / 1024
  const mbValue = value / Math.pow(1024, 2)

  const isFloat = (value) => {
    return value % 1 !== 0
  }

  if (mbValue >= 1) {
    return `${isFloat(mbValue) ? mbValue.toFixed(1) : mbValue} MB`
  }

  return `${isFloat(kbValue) ? kbValue.toFixed(1) : kbValue} KB`
}

export const getInitAdvQueryArray = () => {
  let initAdvQueryArray = [
    {
      root: true,
      queryType: 'matchAll',
      children: [],
      queryArray: [{ key: [], operator: [], value: [] }],
      cursorY: 0
    }
  ]

  return JSON.parse(JSON.stringify(initAdvQueryArray))
}

const isEmptyQueryArray = (queryArray = []) => {
  let truthyArray = []
  for (let i = 0; i <= queryArray.length - 1; i++) {
    const { key = [], operator = [], value = [] } = queryArray[i]

    const queryKey = key[0]?.value
    const queryOperator = operator[0]?.value
    const queryValue = value[0]?.value

    queryArray[i].keyError = !queryKey
    queryArray[i].valueError = !queryValue
    queryArray[i].operatorError = !queryOperator

    if (!queryKey || !queryOperator || !queryValue) {
      // if(queryKey==='taxonomies' && queryOperator==='$exists' && !queryValue ){
      //   return
      // }

      // DONT REMOVE THIS, this is commented for SEPT 11 release
      // null not null check
      if (queryOperator === '$exists' && typeof queryValue !== 'undefined') {
        return false
      }
      truthyArray.push(true)
      // return true
    }
  }
  return truthyArray.includes(true)
}

export const validateAdvanceQuery = (advanceQueryArray, errorObject) => {
  console.log('🚀 ~ validateAdvanceQuery ~ advanceQueryArray:', advanceQueryArray)
  for (let queryObject of advanceQueryArray) {
    const queryArray = queryObject.queryArray

    if (queryObject.error_cursor && queryObject.error_cursor > 0) {
      errorObject.isErrorCursorFound = true
      errorObject.errorMessage = queryObject.errorMessage
    }

    if (!queryObject.children.length && !queryArray.length) {
      errorObject.isQueryEmpty = true
    }

    //console.log('isQ', isEmptyQueryArray(queryArray))

    if (queryArray.length && isEmptyQueryArray(queryArray)) {
      errorObject.isQueryEmpty = true
    }

    if (queryObject.children.length) {
      validateAdvanceQuery(queryObject.children, errorObject)
    }
  }
}

export const getLocalizedOptions = ({ languages, selectedLanguageValue }) => {
  let itrCount = 0

  const languagesDict = languages.reduce((acc, current) => {
    acc[current.value] = current
    return acc
  }, {})

  const options = [{ label: 'Any Locales', value: '$any' }]

  let currentLocale = selectedLanguageValue

  while (currentLocale && itrCount < languages.length) {
    options.push(languagesDict[currentLocale])
    currentLocale = languagesDict[currentLocale].fallback_locale
    itrCount++
  }

  return options
}

export const getQueryType = (queryString = ''): 'basicQuery' | 'advanceQuery' => {
  const defaultQueryType = 'basicQuery'
  if (!queryString) return defaultQueryType

  // eslint-disable-next-line no-useless-escape
  const andRegex = /\"\$and\":/g
  // eslint-disable-next-line no-useless-escape
  const orRegex = /\"\$or\":/g

  const ands = queryString.match(andRegex) || []
  const ors = queryString.match(orRegex) || []

  const notPublishMatch = queryString.match('_publish_details') || []

  if (ors.length === 2 && ands.length <= 1 && notPublishMatch.length >= 1 && queryString.includes('locale')) {
    return 'basicQuery'
  }

  if (ors.length === 1 && ands.length <= 1) {
    if (notPublishMatch.length >= 1 || queryString.includes('locale')) {
      return 'basicQuery'
    }
  }

  if (ands.length <= 1 && !ors.length) {
    return 'basicQuery'
  }

  return 'advanceQuery'
}

const FilterFocusCN = {
  defaultActiveClass: 'AdvancedQueryView__suggestion-item--selectable',
  taxonomyActiveClass: 'tableFilterModal__suggestion-item-taxonomy--selectable'
}

function getFocusableElementById(parentId, isTaxonomyTerm = false) {
  const activeClass = isTaxonomyTerm ? FilterFocusCN.taxonomyActiveClass : FilterFocusCN.defaultActiveClass

  return document.getElementById(parentId)?.getElementsByClassName(activeClass)
}

function focusNextElement(parentId, activeLi, isTaxonomyTerm) {
  const focusable: any = getFocusableElementById(parentId, isTaxonomyTerm)

  if (focusable && focusable.length) {
    const index = [...focusable].indexOf(activeLi)
    if (index > -1) {
      return focusable[index + 1] || undefined
    }
  }
  return
}

function focusPreviousElement(parentId, activeLi, isTaxonomyTerm) {
  const focusable: any = getFocusableElementById(parentId, isTaxonomyTerm)
  if (focusable && focusable.length) {
    const index = [...focusable].indexOf(activeLi)
    if (index > -1) {
      return focusable[index - 1] || undefined
    }
  }
  return
}

function focusFirstList(parentId, isTaxonomyTerm) {
  const focusable: any = getFocusableElementById(parentId, isTaxonomyTerm)
  focusable?.[0]?.focus()
}

function getActiveList(isTaxonomyTerm) {
  const activeClass = isTaxonomyTerm ? FilterFocusCN.taxonomyActiveClass : FilterFocusCN.defaultActiveClass
  const activeElement = document.activeElement
  if (activeElement?.classList.contains(activeClass)) {
    return activeElement || null
  }
  return null
}

export const tableFilterKeyBindingHelper = (event, parentId, options = {}) => {
  const { queryType, type }: any = options
  const isTaxonomyTerm = type === 'value' && queryType === 'taxonomyTermLabel'

  const activeElement: any = getActiveList(isTaxonomyTerm)

  const { key } = event
  switch (key) {
    case 'ArrowDown':
      if (activeElement) {
        focusNextElement(parentId, activeElement, isTaxonomyTerm)?.focus()
        // console.log('ArrowDown focusNextElement', focusNextElement(parentId, activeElement, isTaxonomyTerm))
      } else {
        focusFirstList(parentId, isTaxonomyTerm)
        event.stopPropagation()
        event.preventDefault()
        // console.log('ArrowDown focusFirstList', focusFirstList(parentId, isTaxonomyTerm))
      }
      break
    case 'ArrowUp':
      if (activeElement) focusPreviousElement(parentId, activeElement, isTaxonomyTerm)?.focus()
      else {
        focusFirstList(parentId, isTaxonomyTerm)
        event.stopPropagation()
        event.preventDefault()
      }
      break

    case 'Enter':
      if (activeElement && !(queryType === 'localizedInLabel' && type === 'value') && !isTaxonomyTerm) {
        event.stopPropagation()
        event.preventDefault()
        activeElement.click()
      }
      break
    default:
      break
  }
}

// export function getLastSelectableDate() {
//   let selectableDates
//   let lastSelectableDatesElement: HTMLDivElement | null = null
//   const parent = document.getElementsByClassName('tableFilterModalDateUi')
//   if (parent && parent.length) selectableDates = parent[0].querySelectorAll("div.react-datepicker__day[tabindex='0']")

//   if (selectableDates && selectableDates.length)
//     lastSelectableDatesElement = selectableDates[selectableDates.length - 1] as HTMLDivElement

//   return lastSelectableDatesElement
// }
